/* src/app/shared/dialog/screen-dialog/screen-information/screen-information.component.scss */
.tv-ns-primary-large-button-on-light-bg {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 8px 16px;
  font: 700 13px FranceTV Brown;
  background-color: #F03C64;
  border: 1px solid #F03C64;
  color: #FFF;
}
.tv-ns-primary-large-button-on-light-bg:hover {
  background-color: #CC3456;
  border: 1px solid #CC3456;
}
.tv-ns-primary-large-button-on-light-bg:disabled {
  background-color: #DFEBF7;
  border: 1px solid #DFEBF7;
  color: #6B90B3;
}
.tv-ns-primary-large-button-on-dark-bg {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 8px 16px;
  font: 700 13px FranceTV Brown;
  border: 1px solid #F03C64;
  background-color: #F03C64;
  color: #FFF;
}
.tv-ns-primary-large-button-on-dark-bg:hover {
  border: 1px solid #F03C64;
  background-color: transparent;
}
.tv-ns-primary-large-button-on-dark-bg:disabled {
  border: 1px solid #244666;
  background-color: rgba(223, 235, 247, 0.1);
  color: #6B90B3;
}
.tv-ns-secondary-large-button-on-light-bg {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 8px 16px;
  font: 700 13px FranceTV Brown;
  background-color: #FFF;
  color: #244666;
  border: 1px solid #244666;
}
.tv-ns-secondary-large-button-on-light-bg:hover {
  background-color: #244666;
  border: 1px solid #244666;
  color: #FFF;
}
.tv-ns-secondary-large-button-on-light-bg:hover svg path {
  fill: #FFF !important;
}
.tv-ns-secondary-large-button-on-light-bg:disabled {
  background-color: #DFEBF7;
  border: 1px solid #DFEBF7;
  color: #6B90B3;
}
.tv-ns-secondary-large-button-dark-bg {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 8px 16px;
  font: 700 13px FranceTV Brown;
  background-color: transparent;
  color: #DFEBF7;
  border: 1px solid #DFEBF7;
}
.tv-ns-secondary-large-button-dark-bg:hover {
  border: 1px solid #DFEBF7;
  background-color: #DFEBF7;
  color: #244666;
}
.tv-ns-secondary-large-button-dark-bg:disabled {
  border: 1px solid #244666;
  background-color: rgba(223, 235, 247, 0.1);
  color: #6B90B3;
}
.tv-ns-validation-large-button {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 8px 16px;
  font: 700 13px FranceTV Brown;
  background-color: #00D78C;
  border: 1px solid #00D78C;
  color: #FFF;
}
.tv-ns-validation-large-button:hover {
  background-color: #26C18B;
  border: 1px solid #26C18B;
}
.tv-ns-validation-large-button:disabled {
  background-color: #DFEBF7;
  border: 1px solid #DFEBF7;
  color: #6B90B3;
}
.tv-ns-validation-small-button {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 2px 8px;
  font: 400 10px FranceTV Brown;
  background-color: #00D78C;
  border: 1px solid #00D78C;
  color: #FFF;
}
.tv-ns-validation-small-button mat-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 3px;
  padding-top: 1px;
  font-size: 14px;
  width: 14px;
  height: 14px;
}
.tv-ns-validation-small-button:hover {
  background-color: #26C18B;
  border: 1px solid #26C18B;
}
.tv-ns-validation-small-button:disabled {
  background-color: #DFEBF7;
  border: 1px solid #DFEBF7;
  color: #6B90B3;
}
.tv-ns-small-blue-button {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 2px 8px;
  font: 400 10px FranceTV Brown;
  background-color: #0083FF;
  border: 1px solid #0083FF;
  color: #FFF;
}
.tv-ns-small-blue-button mat-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 3px;
  padding-top: 1px;
  font-size: 14px;
  width: 14px;
  height: 14px;
}
.tv-ns-small-blue-button:hover {
  background-color: #FFF;
  border: 1px solid #0083FF;
  color: #0083FF;
}
.tv-ns-small-blue-button:disabled {
  background-color: #DFEBF7;
  border: 1px solid #DFEBF7;
  color: #6B90B3;
}
.information-container {
  display: flex;
  width: 928px;
  height: auto;
  padding-top: 10px;
  gap: 25px;
}
.block-info {
  flex-direction: column;
  display: flex;
  height: auto;
  padding: 15px;
  border-radius: 5px;
  background: rgba(36, 70, 102, 0.05);
  gap: 10px;
}
.block-info-tarifs {
  flex-direction: column;
  display: flex;
  height: auto;
  padding: 15px;
  border-radius: 5px;
  background: rgba(36, 70, 102, 0.05);
  gap: 10px;
  flex-grow: 2;
  flex-shrink: 2;
}
.block-date {
  display: flex;
  flex-direction: row;
}
.block-type {
  display: flex;
  flex-direction: row;
  height: auto;
  padding: 15px;
  border-radius: 5px;
  background: rgba(36, 70, 102, 0.05);
  justify-content: space-between;
}
.width-custom {
  width: 50%;
}
.title-custom {
  justify-content: flex-start;
  color: #F03C64;
  font: 400 14px FranceTV Brown;
}
.label {
  font: 400 14px FranceTV Brown;
  color: #6B90B3 !important;
  height: 15px;
  padding-top: 16px;
}
.label-float {
  color: #6B90B3 !important;
  font-size: 11px;
  padding-left: 10px;
  height: 10px;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.span-padding {
  padding: 0px 3px;
}
.input-value {
  width: 17px;
}
.hour-diff {
  display: flex;
  width: 190px;
  height: 60px;
  padding: 10px 0 10px 0;
  border: 1px solid #DFEBF7;
  border-radius: 5px;
  background-color: #FFF;
  margin: 10px 0px;
}
.hour-diff:hover {
  border: 1px solid rgba(107, 144, 179, 0.6);
}
.input-left {
  padding-left: 15px;
}
.small-icon {
  width: 15px;
  height: 15px;
  font-size: 15px;
  margin-right: 5px;
}
.type-container {
  padding-top: 10px;
}
.lib {
  font-size: 14px !important;
  margin-top: 10px;
}
.icon-cancel {
  color: #FFF;
}
.disabled {
  background: rgba(36, 70, 102, 0.05);
}
.inactive-hour-select-button {
  background: #F2F4F5;
}
.option-div {
  display: flex;
  flex-direction: row;
  justify-content: end;
}
.option-mixte-div {
  margin-top: 5px;
}
.forcable-button {
  border: none;
  background: #FFF;
}
.h4-label {
  color: #F03C64;
  font-size: 400 14px FranceTV Brown;
  padding-top: 5px;
  padding-right: 10px;
}
.prices-values {
  text-align: left !important;
}
.forcable-select-button {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  color: #6B90B3;
  min-width: 200px;
  padding: 4px 0px 4px 5px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 32px;
  background-color: #FFF;
}
.tv-mixte-choice-chip-list {
  display: flex;
  align-items: center;
  padding: 5px;
  gap: 5px;
  color: #6B90B3;
  background-color: #FFF;
  border-radius: 100px;
}
.tv-mixte-choice-chip-list-item {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #DFEBF7;
  color: #6B90B3;
  border-radius: 100px;
  padding: 4px 15px;
  height: 26px;
  cursor: pointer;
  font: 400 14px FranceTV Brown;
}
.tv-mixte-choice-chip-list-item:hover {
  background-color: #FFF;
  color: #244666;
}
.tv-mixte-choice-chip-list-item-selected {
  background-color: #00D78C;
  color: #FFF;
}
.tv-mixte-choice-chip-list-item-selected:hover {
  background-color: #26C18B;
  color: #FFF;
}
.vertical-separator {
  height: 2px;
  background-color: #DFEBF7;
  margin: auto;
  margin-right: -10px;
  width: 10%;
  transform: rotate(-90deg);
  align-self: stretch;
}
.all-reg-duration {
  display: flex;
  flex-direction: row;
  gap: 20px;
}
.nat-reg-duration {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.duration-total {
  width: -webkit-fill-available;
}
.transfer-block {
  display: flex;
  flex-direction: column;
  gap: 33px;
}
.context-block {
  display: flex;
  flex-direction: row;
  gap: 60px;
}
/*# sourceMappingURL=screen-information.component.css.map */
